import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";

// Register chart components
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const BarChart = ({ data }) => {
  // Extract labels (days) and data (leads)
  const labels =  Array.isArray(data) && data.length > 0 && data?.map(item => item.day);
  const leadsData = Array.isArray(data) && data.length > 0 && data?.map(item => item.leads);

  const chartData = {
    labels: labels, // Dynamic labels from props
    datasets: [
      {
        data: leadsData, // Dynamic data from props
        backgroundColor: "#337FE0",
        borderRadius: 1, // Rounds both top and bottom
        borderSkipped: false, // Ensures full capsule shape
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Hide legend
      },
    },
    scales: {
      x: {
        display: true, // Show x-axis labels
        grid: {
          display: false, // Hide grid lines for x-axis
        },
      },
      y: {
        display: false, // Hide y-axis
        grid: {
          display: false, // Hide grid lines for y-axis
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <div style={{ width: "250px", height: "120px" }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default BarChart;
